// Asking for your account and data to be erased — CCT-473.
//
// ⚠️ THE REQUEST IS RECORDED, THE ERASURE IS NOT IMMEDIATE, and the screen says so. The deletion
// that actually works lives in the back-office, where the cascade is built from the real foreign
// keys; a second one written by hand would drift and leave rows behind while reporting success.
//
// ⚠️ NOTHING IDENTIFIES THE ACCOUNT IN THE BODY. The server reads the email from the token, so a
// caller cannot ask for someone else's account to be deleted.
import { apiFetch } from './client';

export type DemandeSuppression = {
  requested: boolean;
  requestedAt?: string | null;
  status?: string | null;
  doneAt?: string | null;
};

const ROUTE = '/me/account/deletion-request';

/** What the server knows about this learner's request, or `null` if it could not be read. */
export async function lireDemandeSuppression(token: string | null): Promise<DemandeSuppression | null> {
  try {
    return ((await apiFetch(ROUTE, { token, auth: true })) as DemandeSuppression) ?? null;
  } catch {
    return null;
  }
}

/** Record the request. Idempotent server side: asking twice does not restart the deadline. */
export async function demanderSuppression(token: string | null): Promise<DemandeSuppression | null> {
  try {
    return ((await apiFetch(ROUTE, { method: 'POST', token, auth: true })) as DemandeSuppression) ?? null;
  } catch {
    return null;
  }
}

/** Withdraw a request that has not been honoured yet. */
export async function annulerSuppression(token: string | null): Promise<boolean> {
  try {
    const r = (await apiFetch(ROUTE, { method: 'DELETE', token, auth: true })) as { cancelled?: boolean };
    return Boolean(r?.cancelled);
  } catch {
    return false;
  }
}
